import React from 'react';
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';
import { ArcaComponent } from '../../pages/ArcaComponent';

export class LogItem extends ArcaComponent {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <Card style={{ backgroundColor: '#81CEEA', borderColor: '$colour-primary' }} >
                <CardBody>
                    <CardTitle>{this.props.log.System} - {this.props.log.Severity} ({this.props.log.Date.ToDateTimeString})</CardTitle>
                    <CardText>{this.props.log.Text}</CardText>
                    {this.props.log.Date.Exception
                        ? <CardText>{this.props.log.Date.Exception}</CardText>
                        : null}
                </CardBody>
            </Card>
        )
    }
}